import getOr from 'lodash/fp/getOr'

const getConfig = (path?: string, defaultValue?: string): any => {
  const configs = (typeof process !== 'undefined' && Object.keys(process?.env).length > 0 && process?.env) || window.env
  if (typeof path === 'undefined' || path === null) return configs
  return getOr(defaultValue, path, configs)
}

export default getConfig
